
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "../Categorys/categorys.scss";
// import axios from "axios";
// import { AiFillEye, AiFillDelete } from "react-icons/ai";
// import { FiEdit } from "react-icons/fi";
// import { API_BASE_URL } from "../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../components/Token";
// import ProductCategory from "../../Masters/ProductCategory/ProductCategory";
// import Dropdown from 'react-bootstrap/Dropdown';
// import { FcReading, FcEmptyTrash, FcOk } from "react-icons/fc";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import EditCategory from "./EditCategory/EditCategory";
// import CategorysDetial from "./CategorysDetial/CategorysDetial";

// function Categorys() {
//   const [data, setData] = useState([]);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editCategoryId, setEditCategoryId] = useState(null);

//   const[ShowdetailsModal,setShowdetailsModal]=useState(false)
//   const headers = useAuthHeaders();

//   const fetchCategories = () => {
//     axios
//       .get(`${API_BASE_URL}/getallcategory`, { headers })
//       .then((response) => {
//         setData(response.data.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const deleteCategory = (Id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to delete this Category?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(`${API_BASE_URL}/deletecategory/${Id}`, { headers })
//           .then(() => {
//             setData((prevData) => prevData.filter((item) => item._id !== Id));
//             Swal.fire({
//               title: "Deleted!",
//               text: "Your Category has been deleted.",
//               icon: "success",
//             });
//           })
//           .catch((error) => {
//             console.error("Error deleting category:", error);
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: error.response?.data?.error || "An error occurred",
//             });
//           });
//       }
//     });
//   };



//   const handleShowdetails = () => setShowdetailsModal(true);
//   const handleClosedetails = () => setShowdetailsModal(false);
//   const handleShow = () => setShowLoginModal(true);
//   const handleClose = () => setShowLoginModal(false);
//   const handleShowEdit = (categoryId) => {
//     setEditCategoryId(categoryId);
//     setShowEditModal(true);
//   };
//   const handleCloseEdit = () => setShowEditModal(false);

//   return (
//     <div className="p-4">
//       <div className="d-flex justify-content-between my-2">
//         <h2 className="m-0 text-uppercase fs-5 fw-medium">Categories</h2>
//         <button onClick={handleShow} className="btn btn-primary">
//           Add Category
//         </button>
//         <ProductCategory
//           show={showLoginModal}
//           handleClose={handleClose}
//           fetchCategories={fetchCategories}
//         />
//       </div>
//       <table className="categorys-table">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, index) => (
//             <tr key={index}>
//               <td className="fs-5">{item.categoryname}</td>
//               <td>
//                 <Dropdown>
//                   <Dropdown.Toggle className="btns border border-0">
//                     <BsThreeDotsVertical />
//                   </Dropdown.Toggle>
//                   <Dropdown.Menu>
//                     <Dropdown.Item>
//                       <Link >
//                         {/* <button className="mx-1 border border-0 btnss" onClick={() => setShowdetailsModal(item._id)}> */}
//                           <FcReading className="m-2 fs-5" /> View
//                         {/* </button> */}
//                       </Link>
//                     </Dropdown.Item>
//                     <Dropdown.Item>
//                       <button
//                         className="mx-1 border border-0 btnss"
//                         onClick={() => deleteCategory(item._id)}
//                       >
//                         <FcEmptyTrash className="m-2 fs-5" /> Delete
//                       </button>
//                     </Dropdown.Item>
//                     <Dropdown.Item>
//                       <button
//                         className="mx-1 border border-0 btnss"
//                         onClick={() => handleShowEdit(item._id)}
//                       >
//                         <FcOk className="m-2 fs-5" /> Edit
//                       </button>
//                     </Dropdown.Item>
//                   </Dropdown.Menu>
//                 </Dropdown>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <EditCategory
//         show={showEditModal}
//         handleClose={handleCloseEdit}
//         categoryId={editCategoryId}
//       />
//       <>
//        {/* <CategorysDetial
//         show={ShowdetailsModal}
//         handleClose={handleClosedetails}
        
//       /> */}
//       </>
//     </div>
//   );
// }

// export default Categorys;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Categorys/categorys.scss";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/index";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthHeaders } from "../../../components/Token";
import ProductCategory from "../../Masters/ProductCategory/ProductCategory";
import Dropdown from 'react-bootstrap/Dropdown';
import { FcReading, FcEmptyTrash, FcOk } from "react-icons/fc";
import { BsThreeDotsVertical } from "react-icons/bs";
import EditCategory from "./EditCategory/EditCategory";
import CategorysDetial from "./CategorysDetial/CategorysDetial";

function Categorys() {
  const [data, setData] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsCategoryId, setDetailsCategoryId] = useState(null);
  const headers = useAuthHeaders();

  const fetchCategories = () => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const deleteCategory = (Id) => {
    console.log(Id)
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/deletecategory/${Id}`, { headers })
          .then(() => {
            setData((prevData) => prevData.filter((item) => item._id !== Id));
            Swal.fire({
              title: "Deleted!",
              text: "Your Category has been deleted.",
              icon: "success",
            });
          })
          .catch((error) => {
            console.error("Error deleting category:", error);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response?.data?.error || "An error occurred",
            });
          });
      }
    });
  };

  const handleShow = () => setShowLoginModal(true);
  const handleClose = () => setShowLoginModal(false);
  const handleShowEdit = (categoryId) => {
    setEditCategoryId(categoryId);
    setShowEditModal(true);
  };
  const handleCloseEdit = () => setShowEditModal(false);
  const handleShowDetails = (categoryId) => {
    setDetailsCategoryId(categoryId);
    setShowDetailsModal(true);
  };
  const handleCloseDetails = () => setShowDetailsModal(false);

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between my-2">
        <h2 className="m-0  fs-5 fw-medium"> List of Types</h2>
        <button onClick={handleShow} className="btn btn-warning">
         Add Type
        </button>
        <ProductCategory
          show={showLoginModal}
          handleClose={handleClose}
          fetchCategories={fetchCategories}
        />
      </div>
      <table className="categorys-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td className="fs-5">{item.categoryname}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle className="btns border border-0">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>
                      <button
                        className="mx-1 border border-0 btnss"
                        onClick={() => handleShowDetails(item._id)}
                      >
                        <FcReading className="m-2 fs-5" /> View
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <button
                        className="mx-1 border border-0 btnss"
                        onClick={() => deleteCategory(item._id)}
                      >
                        <FcEmptyTrash className="m-2 fs-5" /> Delete
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <button
                        className="mx-1 border border-0 btnss"
                        onClick={() => handleShowEdit(item._id)}
                      >
                        <FcOk className="m-2 fs-5" /> Edit
                      </button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <EditCategory
        show={showEditModal}
        handleClose={handleCloseEdit}
        categoryId={editCategoryId}
      />
      <CategorysDetial
        show={showDetailsModal}
        handleClose={handleCloseDetails}
        categoryId={detailsCategoryId}
      />
    </div>
  );
}

export default Categorys;
